import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iti-help',
  templateUrl: './iti-help.component.html',
  styleUrls: ['./iti-help.component.scss'],
})
export class ItiHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {/* empty */}

}
